<template>
  <div class="main__card" v-if="card">
    <v-img
        alt="card"
        width="100%"
        :max-width="card_width"
        aspect-ratio="1/1"
        :src="card_bg"
    />
    <vue-barcode
        v-if="show_code"
        class="main__card_code"
        :value="card.number"
        :options="{ displayValue: false, lineColor: '#313743' }"
    ></vue-barcode>
    <div class="main__card_number">
      <p v-if="show_code">{{ card.number }}</p>
    </div>
    <div v-if="card.expire_date" class="main__card_expire">
      истекает: {{ displayDate(card.expire_date) }}
    </div>
  </div>
  <div v-else>
    <NoData
        :icon="'add_card'"
        :text="'Скоро здесь появится ваша карта'"
    />
  </div>
  <v-row no-gutters :class="(oc_type === 'iPhone' || oc_type === 'Macintosh') && card ? 'mb-2' : oc_type === 'Android' && card ? 'my-2' : ''">
    <v-img
        alt="google_wallet"
        :src="google_wallet"
        v-if="oc_type !== undefined && oc_type === 'Android' && card" class="main__card_btn_bind_google"
        @click="getCardToWallet(card.id)"
    />
    <v-img
        alt="apple_wallet"
        :src="apple_wallet"
        v-if="oc_type !== undefined && (oc_type === 'iPhone' || oc_type === 'Macintosh') && card" class="main__card_btn_bind_apple"
        @click="getCardToWallet(card.id)"
    />
  </v-row>
</template>

<script>
import { defineComponent } from 'vue'
import card_bg from "@/assets/img/card_img.svg"
import google_wallet from "@/assets/img/Save to Google Pay - Russian (Dark).svg"
import apple_wallet from "@/assets/img/RU_Add_to_Apple_Wallet_RGB_102121.svg"
import VueBarcode from "@chenfengyuan/vue-barcode"
import NoData from "@/modules/templates/NoData.vue"
import { mapActions } from "vuex"
import { displayDateCard } from "@/helper"

export default defineComponent({
  name: "UserCard",
  props: {
    card: {
      default: null,
      type: Object
    }
  },
  components: {
    NoData,
    VueBarcode
  },
  data () {
    return {
      card_bg: card_bg,
      google_wallet: google_wallet,
      apple_wallet: apple_wallet,
      show_code: false,
      oc_type: undefined
    }
  },
  computed: {
    card_width () {
      if (this.$vuetify.display.width > 768) {
        return 410
      } else if (this.$vuetify.display.width > 600 && this.$vuetify.display.width <= 768) {
        return 360
      } else if (this.$vuetify.display.width < 370) {
        return 220
      } else {
        return 290
      }
    },
  },
  methods: {
    ...mapActions({
      bindAppleWallet: 'personal_account/members/cards/bindAppleWallet',
      bindGoogleWallet: 'personal_account/members/cards/bindGoogleWallet'
    }),
    displayDate: displayDateCard,
    getCardToWallet (card_id) {
      if (this.oc_type === 'iPhone' || this.oc_type === 'Macintosh') {
        this.bindAppleWallet({
          card_id: card_id,
          finalizer: (data) => {
            const a = document.createElement("a")
            a.href = URL.createObjectURL(data)
            a.download = `${this.card.number}.pkpass`
            a.click()
          },
          catcher: () => {}
        })
      } else if (this.oc_type === 'Android') {
        this.bindGoogleWallet({
          card_id: card_id,
          finalizer: (data) => {
            const newTab = window.open(data.pay_link, '_blank')
            // Перенаправляем пользователя на новую вкладку
            newTab.focus()
          },
          catcher: () => {}
        })
      } else {
        // Сделать красиво
        alert('Ваше устройство не было распознано.')
      }
    }
  },
  beforeMount () {
    // Получаем User-Agent строку из объекта navigator
    const userAgent = navigator.userAgent
    // Проверяем наличие определенных ключевых слов в User-Agent строке для определения ОС
    if (userAgent.match(/Android/i)) {
      // ОС Android
      this.oc_type = 'Android'
    } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
      // ОС iOS (iPhone, iPad, iPod)
      this.oc_type = 'iPhone'
    } else if (userAgent.match(/Macintosh/i)) {
      // ОС Macintosh
      this.oc_type = 'Macintosh'
    } else {
      this.oc_type = undefined
    }
  },
  mounted () {
    setTimeout(() => {
      this.show_code = true
    }, 300)
  }
  // created () {
  //   this.loadData()
  // }
})
</script>

<style scoped lang="scss">
.main__card {
  display: inline-block;
  position: relative;
  min-height: 220px;
}

.main__card_code {
  position: absolute;
  bottom: 44px;
  left: 35px;
  height: 80px;
  width: 340px;
}

.main__card_number {
  position: absolute;
  bottom: 30px;
  left: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 410px;
  color: #313743;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.5rem;
}

.main__card_btn_bind_google {
  margin-bottom: -50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  //position: absolute;
  //bottom: -5px;
  //left: -4px;
  width: 288px;
  height: 44px;
  cursor: pointer;
}

.main__card_btn_bind_apple {
  margin-bottom: -50px !important;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  //position: absolute;
  //bottom: -2px;
  //left: 0;
  width: 200px;
  height: 50px;
  cursor: pointer;
}

.main__card_expire {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 15px;
  height: 30px;
  background-color: #376FFE;
  color: white;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  cursor: pointer;
}

.edit__member {
  content: "";
  display: inline-flex;
  position: absolute;
  left: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  width: 227px;
  height: 30px;
  background-color: #376FFE;
  border-radius: 0 5px;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}

@media screen and (max-width: 768px) {
  .main__card_code {
    bottom: 46px;
    left: 30px;
    height: 60px;
    width: 300px;
  }

  .main__card_number {
    bottom: 29px;
    left: 2px;
    width: 360px;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.4rem;
  }

  .main__card_btn_bind_apple {
    height: 45px;
  }
}

@media screen and (max-width: 600px) {
  .main__card_code {
    bottom: 38px;
    left: 25px;
    height: 50px;
    width: 240px;
  }

  .main__card_number {
    bottom: 23px;
    width: 290px;
    letter-spacing: 0.3rem;
  }

  .main__card_btn_bind_google {
    width: 240px;
    height: 35px;
    //bottom: -4px;
    //left: -3px;
  }

  .main__card_btn_bind_apple {
    height: 40px;
  }
}

@media screen and (max-width: 369px) {
  .main__card_code {
    bottom: 30px;
    left: 18px;
    height: 36px;
    width: 184px;
  }

  .main__card_number {
    bottom: 17px;
    left: 0;
    width: 220px;
    letter-spacing: 0.1rem;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
  }
}
</style>
